import FlexLayout, { FlexLayoutProps } from "../Flexbox/FlexLayout.component";
import cx from "classnames";
import styles from "./FullPageLayout.module.css";
import match from "@jnctn/fp/match";

export type Type = "black" | "gray" | "white" | "gradient";

const backgroundClass = match<Type, string>(
  ["black", "bg-black"],
  ["gray", "bg-charcoal-200"],
  ["white", "bg-white"],
  ["gradient", styles.gradient]
);

export default function FullPageLayout({
  className,
  type = "black",
  ...props
}: FlexLayoutProps & { type?: Type }) {
  return (
    <FlexLayout
      {...props}
      className={cx(
        "fixed top-0 bottom-0 left-0 right-0 overflow-hidden",
        backgroundClass(type),
        className
      )}
    />
  );
}
